import AnalysisDataCriteria from 'use-case/analysis/analysisCriteria';
import Analysis from 'domain/entity/analysis';
import { getApiClient } from 'adapter/out/client/apiClient';
import { parseAnalysisDataCriteria } from 'adapter/out/client/analysis/parseAnalysis';

const updateAnalysisApiClient = getApiClient(
    (clientCriteria: AnalysisDataCriteria) => `dashboards/analyses/${clientCriteria.analysisId}`,
    Analysis,
    (clientCriteria: AnalysisDataCriteria) => ({
        method: 'PUT',
        body: JSON.stringify(parseAnalysisDataCriteria(clientCriteria)),
        headers: { 'Content-Type': 'application/json' },
    })
);

export default updateAnalysisApiClient;
